import { Alert as MuiAlert, AlertColor, AlertProps, styled, Theme } from "@mui/material";
import { pxToRem } from "../../utils/fontSizeUtility";
import React from "react";

export const Alert = styled(
  MuiAlert,
  {}
)<AlertProps>(({ theme, severity }) => ({
  width: "unset",
  borderWidth: pxToRem(1),
  borderStyle: "solid",
  color: theme.palette.text.primary,
  ...getDynamicColors(theme, severity ?? "error"),
})) as React.ComponentType<AlertProps>;

function getDynamicColors(theme: Theme, severity: AlertColor) {
  const alphaChannel = "1F";
  const warningAlphaChannel = "0F";

  switch (severity) {
    case "success":
      return {
        backgroundColor: theme.palette.success.main + alphaChannel,
        borderColor: theme.palette.success.main,
      };
    case "info":
      return {
        backgroundColor: theme.palette.info.main + alphaChannel,
        borderColor: theme.palette.info.main,
      };
    case "warning":
      return {
        backgroundColor: theme.palette.warning.main + warningAlphaChannel,
        borderColor: theme.palette.warning.main,
      };
    case "error":
      return {
        backgroundColor: theme.palette.error.main + alphaChannel,
        borderColor: theme.palette.error.main,
      };
    default:
      const _exhaustiveCheck: never = severity;
      return _exhaustiveCheck;
  }
}
